/**
 * save-blob.ts — the browser "save a downloaded blob to disk" DOM helper.
 *
 * Broker-app-side twin of `apps/web/src/portal/lib/save-blob.ts` (same DOM
 * concern — objectURL → temp <a download> click → revoke — kept as a separate
 * copy because the portal and broker app are distinct bundles with their own
 * `lib/`; no cross-bundle import). Used by the DMS Ablage grid + inline viewer
 * for single-document and batch-ZIP downloads (dms/spec.md §M11).
 *
 * [Source: apps/web/src/portal/lib/save-blob.ts]
 */

/** Fire the browser save for a downloaded blob (DOM concern — no business logic). */
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
